import { render } from "./PodsDataTable.vue?vue&type=template&id=71b44564&scoped=true"
import script from "./PodsDataTable.vue?vue&type=script&lang=js"
export * from "./PodsDataTable.vue?vue&type=script&lang=js"

import "./PodsDataTable.vue?vue&type=style&index=0&id=71b44564&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b44564"]])

export default __exports__